import { chatbotHttp as api } from "./chatbotApi";

export const getSchedulerTrigger = () => api.get("/admin/scheduler-trigger").then((r) => r.data.data);
export const updateSchedulerTrigger = (body) => api.put("/admin/scheduler-trigger", body).then((r) => r.data.data);
